<template lang="pug">
  div(:style="'min-height:'+h")
    div.px-0.white.detail-head
      el-row.pl-5
        el-col(:span="8")
          Breadcrumb(:data="items")
        el-col.pt-5.text-right(:span="15")
          el-button(v-if="true" type="primary" size="mini" :loading="loading" @click="add") 生成订单
          el-button(v-if="true" type="primary" size="mini" @click="goto('/purchase/purchase_order')") 返回
    div(style="height:70px")
    el-main.white.pa-3.ma-4
      el-row.py-3(type="flex" justify="center" :gutter="10")
        el-col(:span="4")
          el-select.w-100(v-model="list.supplier" size="mini" filterable remote placeholder="请搜索供应商" :remote-method="getSupplyList" :loading="loadingSupply" clearable)
            el-option(v-for="item in supply" :key="item.code" :label="item.name" :value="item.code")
        el-col(:span="4")
          el-input.w-100(v-model="list.code" size="mini" placeholder="请输入合同号" clearable)
        el-col(:span="4")
          el-input.w-100(v-model="list.code_material" size="mini" placeholder="请输入物料编码" clearable)
        el-col(:span="4")
          el-input.w-100(v-model="list.name_material" size="mini" placeholder="请输入物料名称" clearable)
        el-col(:span="4")
          el-select.w-100(v-model="list.buy_org" size="mini" :filter-method="sourcebuyorg" filterable placeholder="采购组织" clearable)
            el-option(v-for="item in buyorg" :key="item.pk_org" :label="item.name" :value="item.pk_org")
        el-col(:span="4")
          el-button(type="primary" @click="getCtList" size="mini" :loading="loading") 查询
          el-button(@click="clear" size="mini" :loading="loading") 重置
      template(v-for="(item,i) in data")
        div.grey--lighten1.pl-3.py-3(style="line-height:24px;font-size:14px;color:#909399;font-weight: bold;")
          el-row(:gutter="20")
            el-col(:span="6")
              span 合同号：{{item.head.code}}
            el-col(:span="10")
              span 采购组织：{{item.head.name_buy_org}}
            el-col(:span="4")
              span 采购员：{{item.head.name_buy_person}}
            el-col(:span="4")
              span 联系方式：{{item.head.mobile_buy_person}}
        el-divider.my-0
        el-table.mb-5(:data="item.body" style="width: 100%" border header-cell-class-name="grey--lighten1" size="mini" row-key="id" @selection-change="handleSelectionChange($event,i)")
          el-table-column(type="selection" :selectable="checkStatus" width="50")
          el-table-column(prop="row_num" label="行号" width="60")
          el-table-column(prop="code_material" label="物料编码" show-overflow-tooltip)
          el-table-column(prop="name_material" label="物料名称" show-overflow-tooltip)
          el-table-column(prop="name_stock_org" label="收货组织" show-overflow-tooltip)
          el-table-column(prop="taxprice" label="含税单价" width="80" show-overflow-tooltip)
          el-table-column(prop="tax" label="税率" width="60")
          el-table-column(prop="num_h" label="数量" show-overflow-tooltip)
            template(slot-scope="scope")
              span {{scope.row.num_h==-1?'不限':scope.row.num_h}}
          el-table-column(prop="num" label="可执行数量" show-overflow-tooltip)
            template(slot-scope="scope")
              el-input-number(v-if="scope.row.num_h==-1" size="mini" v-model="scope.row.num" :precision="3" controls-position="right" :min="0" placeholder="可执行数量" @blur="setValue(scope.row)")
              el-input-number(v-else v-model="scope.row.num" size="mini" :precision="3" controls-position="right" :min="0" :max="scope.row.num_h" placeholder="可执行数量")
      el-pagination.my-4.text-center(@size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="list.page_num" :page-sizes="page_sizes" :page-size="list.page_size" layout="total,sizes, prev, pager, next, jumper" :total="count" background)
</template>
<script>
export default {
  data() {
    return {
      h: "",
      data: [],
      loading: false,
      items: [
        {
          path: "/purchase/purchase_demand",
          meta: {
            title: "采购订单",
          },
        },
        {
          path: this.$route.path,
          meta: {
            title: "新增采购订单",
          },
        },
      ],
      list: {
        buy_org: null,
        code: null,
        code_material: null,
        name_material: null,
        supplier: null,
        page_num: 1,
        page_size: 10,
      },
      count: 0,
      supply: [],
      loadingSupply: false,
      multipleSelection: [],
    };
  },
  methods: {
    clear() {
      this.list.buy_org = null;
      this.list.code = null;
      this.list.code_material = null;
      this.list.name_material = null;
      this.list.name_material = null;
      this.list.page_num = 1;
      this.getCtList();
    },
    setValue(e) {
      if (!e.num) {
        e.num = 0;
      }
    },
    // eslint-disable-next-line no-unused-vars
    checkStatus(row, rowIndex) {
      if (parseFloat(row.num_h) == 0) {
        return false;
      } else {
        return true;
      }
    },
    handleSelectionChange(val, i) {
      this.multipleSelection[i] = val;
    },
    async getSupplyList(query) {
      if (!query) {
        return false;
      }
      localStorage.setItem("PurchaseOrderAdd_query", query);
      this.loadingSupply = true;
      let res = await this.$api.supplier.getotherList({
        key_name: query,
        page_num: 1,
        page_size: 100,
        no_check: 1,
        checkstatus: 3,
      });
      this.loadingSupply = false;
      if (res) {
        this.supply = res.data;
      }
    },
    handleSizeChange(e) {
      this.list.page_size = e;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    handleCurrentChange(e) {
      this.list.page_num = e;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    async getCtList() {
      this.loading = true;
      let res = await this.$api.order.getCtList(this.list);
      this.loading = false;
      if (res) {
        this.data = res.data;
        this.count = res.count;
        this.multipleSelection = [];
        for (var i = 0; i < this.data.length; i++) {
          this.$set(this.multipleSelection, i, []);
        }
      }
    },
    async add() {
      let flag = false;
      let data = [];
      for (var i in this.multipleSelection) {
        if (this.multipleSelection[i].length > 0) {
          flag = true;
          data.push({
            head: this.data[i].head,
            body: this.multipleSelection[i],
          });
        }
      }
      if (!flag) {
        this.$notify({
          message: "请选择需要操作的数据",
          type: "error",
        });
        return false;
      }
      this.loading = true;
      let res = await this.$api.order.add(data);
      this.loading = false;
      if (res) {
        this.$notify({
          message: "操作成功",
          type: "success",
        });
        this.goto("/purchase/purchase_order");
      }
    },
    init() {
      let data = this.$route.query;
      if (JSON.stringify(data) != "{}") {
        this.list = this.$utils.cloneDeep(data);
        if (data.page_num) {
          this.list.page_num = parseInt(data.page_num);
        }
        if (data.page_size) {
          this.list.page_size =
              this.page_sizes.indexOf(parseInt(data.page_size)) > -1
                  ? parseInt(data.page_size)
                  : this.page_sizes[0];
        }
        if (this.list.supplier) {
          this.getSupplyList(localStorage.getItem("PurchaseOrderAdd_query"));
        }
      }
      this.getCtList();
    },
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  created() {
    if (this.$store.state.token && this.$store.state.purchase_org == false)
      this.getPurchaseSelfOrg();
  },
  watch: {
    $route: {
      handler: "init",
      immediate: true,
    },
  },
};
</script>
